import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { InputBaseContainer } from '../../../../../molecules';
import StatusChipPicker from '../../../../../molecules/StatusChipPicker';
import { labels } from '../constants';
import { RootState } from '../../../../../redux/root';

const ActivityStatus = ({ control, setValue, watch, setDisableSubmit }) => {
  const { selectedInspection, statusData } = useSelector((s: RootState) => s.inspections);
  const activityStatusValue = watch('activityStatus');
  useEffect(() => {
    setDisableSubmit(true);
  }, [activityStatusValue]);
  useEffect(() => {
    if (selectedInspection.inspectionType && statusData.length > 0) {
      const value = statusData.find(item => item.name === selectedInspection.statusName);
      setValue('activityStatus', value);
    }
  }, [statusData, selectedInspection]);
  return (
    <InputBaseContainer>
      <Controller
        name="activityStatus"
        defaultValue=""
        control={control}
        render={({ value, onChange }) => (
          <StatusChipPicker
            label={labels.activityStatus}
            options={statusData}
            isLoading={statusData.length === 0}
            value={value}
            onChange={onChange}
          />
        )}
      />
    </InputBaseContainer>
  );
};

export default ActivityStatus;
